import { Button, Modal } from "@mantine/core";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";

interface AuthSelectModalProps {
  isOpen: boolean;
  onToggle: () => void;
  onAuthMethodSave: () => void;
}

function AuthSelectModal({
  isOpen,
  onToggle,
  onAuthMethodSave
}: AuthSelectModalProps) {
  return (
    <Modal
      opened={isOpen}
      title="Aktivieren Sie die Zwei-Faktor-Authentifizierung"
      onClose={onToggle}
    >
      <div className="intro">
        <p>
          Die Zwei-Faktor-Authentifizierung fügt Ihrem Konto eine zusätzliche
          Sicherheitsebene hinzu, indem sie neben einem Passwort einen weiteren
          Authentifizierungsschritt zur Anmeldung erfordert.
        </p>
        <p>
          Sie können die 2-Faktor-Authentifizierung über eine spezielle
          Authentifizierungs-App einrichten.
        </p>
        <p>
          Hierfür benötigen Sie eine App wie beispielsweise Google
          Authenticator, Microsoft Authenticator oder Authy. Die App generiert
          zeitbasierte Sicherheitscodes, die Sie bei jeder Anmeldung eingeben
          müssen.
        </p>
      </div>

      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Schließen
        </Button>
        <Button color="secondary" onClick={onAuthMethodSave}>
          Weiter
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { AuthSelectModal, AuthSelectModalProps };
